/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import * as zod from 'zod';


/**
 * API endpoint that allows attachments to be created
 *
 * Any other operation will be handled by the other endpoints such as associating an attachement with a ticket or invoice
 */
export const attachmentsCreateBodyNameMax = 256;



export const AttachmentsCreateBody = zod.object({
  "name": zod.string().min(1).max(attachmentsCreateBodyNameMax),
  "file": zod.instanceof(File),
  "fileType": zod.enum(['pdf', 'image', 'spreadsheet']).describe('\* `pdf` - PDF\n\* `image` - Image\n\* `spreadsheet` - Spreadsheet'),
  "owner": zod.string().uuid().nullish()
}).describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

export const attachmentsCreateResponseNameMax = 256;

export const attachmentsCreateResponseFileRegExp = new RegExp('(?:pdf|jpg|png|jpeg|csv|xls|xlsx)$');


export const AttachmentsCreateResponse = zod.object({
  "id": zod.string().uuid(),
  "name": zod.string().max(attachmentsCreateResponseNameMax),
  "file": zod.string().url().regex(attachmentsCreateResponseFileRegExp),
  "fileType": zod.enum(['pdf', 'image', 'spreadsheet']).describe('\* `pdf` - PDF\n\* `image` - Image\n\* `spreadsheet` - Spreadsheet'),
  "owner": zod.string().uuid().nullish()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

